import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps, mergeExternalProps as _mergeExternalProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("styled-dropdown__arrow-0i4c4m", {
  transition: "0.2s",
  "[data-state=\"open\"] &": {
    transform: "rotate(180deg)"
  }
});
import React from 'react';
import DropdownMenu from '../../primitives/dropdown-menu';
import ColSet from '../../primitives/grid/col-set';
import Typography from '../../primitives/typography';
import Skeleton from '../../primitives/skeleton';
import formatPhoneLink from '../../utils/format-phone-link';
import ArrowDropdown from '../../../images/svg/arrow-header-dropdown.svg';
import HeaderDropdown from './header-dropdown';
import { StyledPhoneDisplay } from './styled-phone-number';
import { phoneCtaColSet, phoneCtaTypography } from './styled-phone-block';
export interface DropdownMenuProps {
  text: string;
  phoneNumber?: string;
  phoneDisplay?: string;
}
const styles = {
  arrow: _staticStyles
};
const StyledDropdown = ({
  text,
  phoneNumber,
  phoneDisplay
}: DropdownMenuProps): JSX.Element => {
  const formattedPhone = phoneNumber ? formatPhoneLink(phoneNumber || phoneDisplay) : undefined;
  const triggerLabel = formattedPhone ? `${text}, ${formattedPhone}, location menu` : `${text} location menu`;
  return <DropdownMenu align="end" name={triggerLabel} title={<ColSet {..._mergeComponentProps({
    breakpoints: {
      dt: {
        between: 10
      }
    },
    css: phoneCtaColSet
  })}>
                    <Typography {..._mergeComponentProps({
      fontSize: "sm",
      css: phoneCtaTypography
    })}>
                        <span>{text}</span>
                        <Skeleton>
                            {formattedPhone && <StyledPhoneDisplay>
                                    {formattedPhone}
                                </StyledPhoneDisplay>}
                        </Skeleton>
                    </Typography>
                    <ArrowDropdown {..._mergeExternalProps({
      css: styles.arrow,
      "aria-hidden": "true",
      focusable: "false"
    })} />
                </ColSet>}>
            <HeaderDropdown />
        </DropdownMenu>;
};
export default StyledDropdown;